export default "__VITE_ASSET__DHD0qY2$__"